// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { CategoryTypeaheadCategoryFragmentDoc } from '../../typeahead/__generated-gql-types__/CategoryTypeahead.generated';
export type BootcampCardBootcampFragment = {
  __typename?: 'Bootcamp';
  id: string;
  slug: string;
  title: string;
  imageLink: string;
  headline: string;
  maximumAttendees?: number | null;
  reviewRate?: number | null;
  reviewCount?: number | null;
  cohorts: Array<{
    __typename?: 'BootcampCohort';
    totalAttendees: number;
    sessions: Array<{
      __typename?: 'CoachingSession';
      id: string;
      startAt: number;
    }>;
  }>;
  coaches: Array<{
    __typename?: 'Coach';
    id: string;
    slug: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
  }>;
};

export type BootcampCardCategoryFragment = {
  __typename?: 'Category';
  id: string;
  slug: string;
  goal: Types.GoalName;
  name: string;
  subCategoryList?: Array<{
    __typename?: 'SubCategory';
    id: string;
    slug: string;
    v2Urn: string;
    name: string;
  }> | null;
};

export const BootcampCardBootcampFragmentDoc = gql`
  fragment BootcampCard_Bootcamp on Bootcamp {
    id
    slug
    title
    imageLink
    headline
    maximumAttendees
    cohorts(timeFilter: UPCOMING) {
      totalAttendees
      sessions {
        id
        startAt
      }
    }
    coaches {
      id
      slug
      user {
        id
        firstName
        lastName
        pictureLink
      }
    }
    reviewRate
    reviewCount
  }
`;
export const BootcampCardCategoryFragmentDoc = gql`
  fragment BootcampCard_Category on Category {
    ...CategoryTypeahead_Category
  }
  ${CategoryTypeaheadCategoryFragmentDoc}
`;
